import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Scanner from './components/Scanner';
import LocationList from './pages/LocationList';
import LocationDetail from './pages/LocationDetail';
import ContainerDetail from './pages/ContainerDetail';
import ItemList from './pages/ItemList';
import ItemDetail from './pages/ItemDetail';
import Login from './pages/Login';
import AuthCallback from './pages/AuthCallback';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import './index.css';

// Protected Route component with Footer
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        minHeight: '100vh' 
      }}>
        <div className="spinner"></div>
      </div>
    );
  }

  return isAuthenticated ? (
    <>
      {children}
      <Footer />
    </>
  ) : (
    <Navigate to="/login" replace />
  );
};

function AppRoutes() {
  return (
    <div className="App">
      <Routes>
        {/* Public routes */}
        <Route path="/login" element={<Login />} />
        <Route path="/auth/callback" element={<AuthCallback />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<TermsOfService />} />
        
        {/* Protected routes */}
        <Route path="/" element={
          <ProtectedRoute>
            <Navbar />
            <LocationList />
          </ProtectedRoute>
        } />
        
        <Route path="/locations/:id" element={
          <ProtectedRoute>
            <Navbar />
            <LocationDetail />
          </ProtectedRoute>
        } />
        
        <Route path="/containers/:id" element={
          <ProtectedRoute>
            <Navbar />
            <ContainerDetail />
          </ProtectedRoute>
        } />
        
        <Route path="/items" element={
          <ProtectedRoute>
            <Navbar />
            <ItemList />
          </ProtectedRoute>
        } />
        
        <Route path="/items/:id" element={
          <ProtectedRoute>
            <Navbar />
            <ItemDetail />
          </ProtectedRoute>
        } />
        
        <Route path="/scan" element={
          <ProtectedRoute>
            <Navbar />
            <Scanner />
          </ProtectedRoute>
        } />
      </Routes>
    </div>
  );
}

function App() {
  return (
    <Router>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </Router>
  );
}

export default App;
